import { Component, Input } from '@angular/core';
import {
    NavController,
    NavParams
} from 'ionic-angular';
import { ApiService } from '../../../../services/api';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { RodeoEventRegistration } from 'model/rodeoEventRegistration';
import { ReportsService } from '../../../../services/reports.service';
import { Sidepot } from '../../../../model/sidepot';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';

@Component({
    selector: 'page-sidepot-report',
    templateUrl: 'report-sidepot.html'

})
export class SidepotReport {
    @Input('rodeo') rodeo: Rodeo;

    selectedRodeoEvent: RodeoEvent;

    documentTitle: any;
    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;

    sidepotRegistrations: any[] = [];

    constructor(private nav: NavController, navParams: NavParams, public api: ApiService, public reportService: ReportsService) {
        if (!this.rodeo)
            this.rodeo = navParams.get('rodeo');

        if (!this.selectedRodeoEvent)
            this.selectedRodeoEvent = navParams.get('rodeoEvent');

        this.printing = navParams.get('printing');

        if (this.printing) {
            setTimeout(() => {
                this.load();
            }, 0);
        }
    }

    load() {
        this.updateRodeoEvent();
        
        this.documentTitle = this.rodeo.name + " - " + 'Entries';
        this.dataLoaded = true;
    }

    updateRodeoEvent() {
        if (!this.selectedRodeoEvent)
            this.selectedRodeoEvent = this.rodeo.rodeoEvents[0];
        
        this.sidepotRegistrations = [];

        for (let h = 0; h < this.selectedRodeoEvent.sidepots.length; h++) {
            this.sidepotRegistrations[h] = this.rodeo.rodeoEvents.flatMap(x => x.registrations).filter(x => x.sidepotIds.some(y => y == this.selectedRodeoEvent.sidepots[h].id));
        }

        this.sidepotRegistrations.forEach((registrations: RodeoEventRegistration[]) => {
            registrations.forEach((registration) => {
                let contestantOneId = registration.teammateHeader ? registration.contestantTwoId : registration.contestantOneId;
                let contestantTwoId = registration.teammateHeader ? registration.contestantOneId : registration.contestantTwoId;
                let horseOneId = registration.teammateHeader ? registration.horseTwoId : registration.horseOneId;
                let horseTwoId = registration.teammateHeader ? registration.horseOneId : registration.horseTwoId;
    
                let allRuns = this.rodeo.rodeoEvents.filter(x => x.id == registration.rodeoEventId).flatMap(x => x.schedules).flatMap(x => x.runs).filter(x => 
                    x.contestantOneId == contestantOneId
                    && (!registration.horseOneId || horseOneId == x.horseOneId)
                    && (!contestantTwoId || contestantTwoId == x.contestantTwoId)
                    && (!registration.horseTwoId || horseTwoId == x.horseTwoId));
        
                let runs = allRuns.filter(x => x.round == 1);
                let maxRuns = 1;
                
                if (this.selectedRodeoEvent.ropingFormat == 'Draw')
                    maxRuns = this.selectedRodeoEvent.drawAmount;
                else if (this.selectedRodeoEvent.ropingFormat == 'PickAndDraw') {
                    maxRuns += this.selectedRodeoEvent.drawAmount;
                }
        
                let run = runs[0];
                if (run && run != null) {
                    registration.run = new RodeoEventRun();
                    (registration as any).runCount = allRuns.filter(x => x.runIdentifier == run.runIdentifier && x.done).length;
                    Object.assign(registration.run, run);
                } else {
                    (registration as any).runCount = '0';
                }
            });
        })
    }

    /*
    async downloadCsv() {
        try {
            var data = await this.reportService.getFullEntryReport(this.rodeo.id, this.showContactInfo);
            
            const blob = new Blob([data as any], { type: "json" })
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.download = this.rodeo.name + "-Alpha-Sheet.csv";
            anchor.href = url;
            anchor.click();
        } catch (error) {
            console.log("Error downloading CSV");
        }
    }
    */

    getSidepotCount(sidepot: Sidepot) {
        return this.rodeo.rodeoEvents.flatMap(x => x.registrations).filter(x => x.sidepotIds.some(y => y == sidepot.id)).length;
    }

    matchRodeoEvents(a, b) {
        return a.id == b.id;
    }

    ionViewDidEnter() {
        setTimeout(() => {
            window.document.title = this.documentTitle;
            window.print();
            this.nav.pop();
        }, 0);
    }

    print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        this.nav.push(SidepotReport, {
            rodeo: this.rodeo,
            rodeoEvent: this.selectedRodeoEvent,
            printing: true,
        }).then(() => { this.popoverActive = false; });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-sidepot.ts